module.exports = __webpack_public_path__ + "static/1-8e8ee9b351df8cbd5ead88cb5dd83f0b.jpg";